import { Box, CircularProgress, Grid, Typography } from "@mui/material"
import { useState, useEffect } from "react";
import TratoService from "../../services/tratos.service";
import CardSearchNav from "../card/CardSearchNav";
import SinResultados from "./SinResultados";
import SearchLoading from "./SearchLoading";

const TabPreServicios = ({textSearch,handleClose}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleSearchServicios = async() => {
        if(textSearch?.length >= 2){
            setIsLoading(true);
            await TratoService.getAll({searchNubi: textSearch,typoSearch:'pre'}).then((data)=>{
                setOptions(
                    data.map((item) =>{
                        return {
                            ...item,
                            tituloCard: `${item?.id_t} - ${item?.nombre_t}`,
                            descripCard: item?.softland ? `Servicio en Softland` : '',
                            empresaCard: 'NUBICOM',
                            keyCard: `${item?.id_t}Ticket`
                        }
                    })
                )
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
    };
    useEffect(() => {
        const delayWrite = setTimeout(() => {
            handleSearchServicios()
        }, 500)
        return () => clearTimeout(delayWrite)
    }, [textSearch])

    return (
        <Grid container>
            { !isLoading ? (
                <>
                    {options && options?.length > 0 ? (
                        options?.map((option)=>(
                            <Grid item xs={12} key={`${option?.keyCard}c`}>
                                <CardSearchNav
                                    item={option}
                                    descripcion={option?.descripCard}
                                    titulo={option?.tituloCard}
                                    key={option?.keyCard}
                                    onCLoseModal={handleClose}
                                    textSearch={textSearch}
                                />
                            </Grid>
                        ))
                    ):(
                        <Grid item xs={12} key='sinPreServ'>
                            <SinResultados />
                        </Grid>
                    )}
                </>
            ):(
                <Grid item xs={12} key='circletabpreserv'>
                    <SearchLoading />
                </Grid>
            )}
        </Grid>
    )
}

export default TabPreServicios